import { ProductSearchListingPage } from './ProductSearchListingPage';

export default ProductSearchListingPage;
